import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar, A11y } from 'swiper';

const Especialidades = (props) => {

    const data = props.data;

    return (
        <section className="tf-section testimonials">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text ">
                            <h5 className="sub-title mb-10" >Lo que nos hace únicos</h5>
                        </div>
                        <style>
                            {`
                            .testimonials .swiper-button-next::after,
                            .testimonials .swiper-button-prev::after {
                                color: #df4421 !important;
                            }
                            `}
                        </style>
                        <Swiper
                            modules={[Navigation, Scrollbar, A11y]}
                            spaceBetween={0}
                            navigation
                            slidesPerView={1}
                            scrollbar={{ draggable: true }}
                            style={{
                                "--swiper-navigation-color": "#df4421"
                            }}
                        >
                            {
                                data.map((data, index) => (

                                    <SwiperSlide key={index}>

                                        <div className="testimonials-box">
                                            <div className="image" style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}>
                                                <img src={data.img} alt="Monteno Servicio" style={{ width: '100%', height: 'auto', aspectRatio: '1/1', objectFit: 'cover', borderRadius: '50%' }} />
                                            </div>

                                            <div className="block-text ">
                                                <h3 className="title text-black">{data.name}</h3>
                                                <div className="message text-black">
                                                    <div className="message-content" data-aos="fade-up" data-aos-duration="1000">
                                                        <p className="text fs-21 mb-4">{data.text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default Especialidades;
